/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationClinicalStaffAliases {
  ACTION_NEW_CLINICAL_STAFF = 'action-new-clinical-staff',
  ADDITIONAL_CONTACT_FIELD = 'additional-contact-field',
  CHECKBOX_1 = 'checkbox-1',
  CHECKBOX_ALREADY_COOPERATIVE = 'checkbox-already-cooperative',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FETCH_CLINICAL_STAFF = 'fetch-clinical-staff',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_7 = 'field-7',
  FIELD_8 = 'field-8',
  FIELD_9 = 'field-9',
  FIELD_LIST = 'field-list',
  FORM_ADDITIONAL = 'form-additional',
  FORM_CLINICAL_STAFF = 'form-clinical-staff',
  FRAGMENT_0 = 'fragment-0',
  INPUT_1 = 'input-1',
  INPUT_2 = 'input-2',
  INPUT_3 = 'input-3',
  INPUT_4 = 'input-4',
  INPUT_5 = 'input-5',
  INPUT_6 = 'input-6',
  INPUT_NAME = 'input-name',
  LAYOUT_CONTACT = 'layout-contact',
  PANEL_CLINICAL_STAFF = 'panel-clinical-staff',
  PANEL_MAIN = 'panel-main',
}
export { ProviderAccreditationClinicalStaffAliases };
